import { perform } from "../request/builder"

const makePerform = requestFn => body => perform(requestFn(body))

const api = definitions => {
  return Object.entries(definitions).reduce((mem, [k, r]) => {
    return { ...mem, [k]: makePerform(r) }
  }, {})
}

export default api
